import "~/scss/pages/demo_page.scss";

$(() => {
    $("#chair").on("mouseover", () => { $("#chair i")[0].classList.add("fade-in-right"); });
    $("#chair").on("mouseout", () => { $("#chair i")[0].classList.remove("fade-in-right"); });

    $("#research-axis").on("mouseover", () => { $("#research-axis i")[0].classList.add("fade-in-right"); });
    $("#research-axis").on("mouseout", () => { $("#research-axis i")[0].classList.remove("fade-in-right"); });
});